import * as React from "react";
const IconShoppingBag1 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M30 29h8.5c.6 0 1-.4 1-1s-.4-1-1-1h-4.2v-2.9c0-.6-.4-1-1-1s-1 .4-1 1V27H30c-3.1 0-5.6 2.5-5.6 5.5S26.9 38 30 38h4c2 0 3.6 1.6 3.6 3.5S36 45 34 45h-8.5c-.6 0-1 .4-1 1s.4 1 1 1h6.8v3c0 .6.4 1 1 1s1-.4 1-1v-2.9c2.9-.2 5.2-2.6 5.2-5.5 0-3-2.5-5.5-5.6-5.5H30c-2 0-3.6-1.6-3.6-3.5S28.1 29 30 29" />
    <path d="m56 54.8-4.2-36.4c-.4-3.3-3.1-5.7-6.4-5.7h-3.6v-.9C41.8 6.4 37.4 2 32 2s-9.8 4.4-9.8 9.8v.9h-3.6c-3.3 0-6 2.5-6.4 5.7L8 54.8c-.2 1.8.4 3.7 1.6 5 1.2 1.4 3 2.2 4.8 2.2h35.1c1.8 0 3.6-.8 4.8-2.2 1.3-1.3 1.9-3.2 1.7-5m-31.8-43C24.2 7.5 27.7 4 32 4s7.8 3.5 7.8 7.8c0 .3 0 .6-.1.9H24.3c-.1-.3-.1-.6-.1-.9m28.7 46.7c-.9 1-2.1 1.5-3.4 1.5h-35c-1.3 0-2.5-.5-3.3-1.5S9.9 56.3 10 55l4.2-36.4c.3-2.3 2.2-4 4.4-4h26.7c2.3 0 4.2 1.7 4.4 4L54 55c.1 1.3-.3 2.6-1.1 3.5" />
  </svg>
);
export default IconShoppingBag1;
